module.exports = __webpack_public_path__ + "img/hywb.2c86d0d4.png";